import NativeAppAwareContainer from './NativeAppAwareContainer';

export default NativeAppAwareContainer;
